import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/memberVisitsSaga";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.memberVisits.rangeOptions);
  const selectedFilters = useSelector((state) => state.memberVisits.selectedFilters.rangeOption);

  const handleUpdateOptions = (data) => {
    dispatch(actionCreators.updateCustomRange(data));
  };

  return (
    <div className="select-box" style={{ width: "360px" }}>
      <p className="offers-title">Date Range</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        includeFilter={false}
        onSelectChange={handleUpdateOptions}
      />
    </div>
  );
};

export default CustomDateRanges;
